import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { getClientPortfoliosAuditColumns } from "./columns";
import { A7OPCVMClientPortfoliosEditCard } from "./edit_card";

const table_name = "a7_opcvm_client_portfolios";

export const A7OPCVMClientPortfoliosEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getClientPortfoliosAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <A7OPCVMClientPortfoliosEditCard id={Number(id)} />
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
